import { render, staticRenderFns } from "./Merge.vue?vue&type=template&id=6e42a273&scoped=true&"
import script from "./Merge.vue?vue&type=script&lang=ts&"
export * from "./Merge.vue?vue&type=script&lang=ts&"
import style0 from "./Merge.vue?vue&type=style&index=0&id=6e42a273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42a273",
  null
  
)

export default component.exports